<template>
  <router-view/>
</template>

<style lang="scss">
/* 重置样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  color: #333;
  background-color: #f7f8fa;
}

#app {
  height: 100%;
}

/* 链接样式 */
a {
  text-decoration: none;
  color: #1976d2;
  transition: color 0.3s;
  
  &:hover {
    color: #4791db;
  }
}

/* 响应式布局通用类 */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 常用间距 */
.mt-10 { margin-top: 10px; }
.mt-20 { margin-top: 20px; }
.mt-30 { margin-top: 30px; }
.mb-10 { margin-bottom: 10px; }
.mb-20 { margin-bottom: 20px; }
.mb-30 { margin-bottom: 30px; }

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 响应式媒体查询 */
@media screen and (max-width: 992px) {
  .container {
    max-width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
}

@media screen and (max-width: 576px) {
  html, body {
    font-size: 13px;
  }
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
